// Function that creates a timer, which can be up to 60 minutes

export function startTimer(duration, element) {
  let timer = duration;

  let timerPointer = setInterval(function () {
    let mins = parseInt(timer / 60, 10);
    let secs = parseInt(timer % 60, 10);

    mins = mins < 10 ? '0' + mins : mins;
    secs = secs < 10 ? '0' + secs : secs;

    element.textContent = mins + ':' + secs;

    if (--timer < 0) {
      clearInterval(timerPointer);
      window.location.reload();
    }
  }, 1000);
}

// Initialize and attach the timer to the node with timer-counter

export function startCountdown() {
  if (document.querySelector('.o-header__timer-addon')) {
    if (document.querySelector('.sticky-header')) {
      document.querySelector('.sticky-header').style.display = 'flex';
    }
    document.querySelector('.o-header__timer-addon').style.display = 'flex';
    let timerPresent = document.querySelectorAll('.timer-counter');

    timerPresent.forEach(function (el) {
      if (typeof el != 'undefined' && el != null) {
        let fifteenMinutes = 60 * 15;
        startTimer(fifteenMinutes, el);
      }
    });

    //Handles the toggling of show/hide behavior required for the timer node
    //and the button inside the header on mobile

    if (window.location.href.indexOf('usd.yourketo.diet') > -1) {
      window.onscroll = function (e) {
        if (document.scrollingElement.scrollTop > 300) {
          document.querySelector('.o-header__timer-addon').style.display = 'none';
          document.querySelector('.hidden-mobile').style.display = 'flex';
        } else {
          document.querySelector('.o-header__timer-addon').style.display = 'flex';
          document.querySelector('.hidden-mobile').style.display = 'none';
        }
        if (document.scrollingElement.scrollTop > 2000 && document.scrollingElement.scrollTop < 2700) {
          document.querySelector('.o-header').style.display = 'none';
        } else {
          document.querySelector('.o-header').style.display = 'block';
        }
      };
    }
  }
}

export function startUpsaleTimer(minutes = 15) {
  const second = 1000,
    minute = second * 60,
    hour = minute * 60,
    day = hour * 24;

  const countDown = new Date().getTime() + minute * minutes + second;
  const x = setInterval(function () {
    const now = new Date().getTime(),
      distance = countDown - now;

    (document.getElementById('days_left').innerText = Math.floor(distance / day)),
      (document.getElementById('hours_left').innerText = Math.floor((distance % day) / hour)),
      (document.getElementById('minutes_left').innerText = Math.floor((distance % hour) / minute)),
      (document.getElementById('seconds_left').innerText = Math.floor((distance % minute) / second));

    if (distance < 0) {
      (document.getElementById('days_left').innerText = '0'), (document.getElementById('hours_left').innerText = '0');
      (document.getElementById('minutes_left').innerText = '0'),
        (document.getElementById('seconds_left').innerText = '0');
      clearInterval(x);
    }
  }, 0);
}
